export default [
  {
    path: "/inspection/setting",
    name: "inspection-setting",
    meta: { title: "巡检设置" },
    component: () =>
      import(
        /* webpackChunkName: "inspection-setting" */ "@/views/inspection-management/setting/index.vue"
      ),
  },
];
